module.exports = __webpack_public_path__ + "assets/img/star_sentence_un_select4.b01d325e.png";